import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AccountApi } from '../../../sdk/services/custom/Account';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { AppApi } from '../../../sdk/services/custom';
import { LoopBackFilter, App, Menuitem } from '../../../sdk/models/';
import 'rxjs/add/operator/filter';
import { PlatformApp } from '../../../services/app.service';
import { AppSettings } from '../../../../app.settings'; //This is my Constant Service
import { MenuitemApi } from '../../../../shared/sdk/services/custom';
import { SimpleNotificationsComponent, NotificationComponent, PushNotificationsService, NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss'],

    providers: [AppSettings, MenuitemApi]
})
export class FullLayoutComponent implements OnInit {
    links: Array<Object>;
    pagevalues;

    public disabled: boolean = false;
    public status: { isopen: boolean } = { isopen: false };

    nocontainerpadding: boolean = false;
    hidebreadcrumbs: boolean = false;
    userdata: any;
    appId: any;
    app: any;
    user: any;
    iconurl: any;
    notifyOptions = PlatformApp.getNotificationOptions();
    filter: LoopBackFilter = <LoopBackFilter>{
        'where': {}
    };

    apptype;
    menuitems;

    menuitemFilter: LoopBackFilter = <LoopBackFilter>{
        'where': {}
    };

    constructor(private router: Router, private route: ActivatedRoute,
        private accountApi: AccountApi, private _AppApi: AppApi,
        private MenuitemApi: MenuitemApi, private AppSettings: AppSettings,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private auth: LoopBackAuth, private _PlatformApp: PlatformApp) {
    }
    ngOnInit(): void {
        this.setAppType();
        this.setMenuItems();

        this.userdata = this.auth.getCurrentUserData();
        this.appId = this.userdata.appId;
        this.user = this.userdata.email;
        // this.filter.where["appId"] = this.userdata.appId;  

        this._AppApi.findById(this.userdata.appId).subscribe((results) => {
            this.app = results;
            this.iconurl = this.app.iconurl;
            PlatformApp.setApp(this.app);
        });

        this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
            this.links = [];
            let currentRoute = this.route.root,
                url = '';

            do {
                let childrenRoutes = currentRoute.children;

                currentRoute = null;
                childrenRoutes.forEach(route => {
                    if (route.outlet === 'primary') {
                        let routeSnapshot = route.snapshot;
                        url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                        this.links.push({
                            label: route.snapshot.data,
                            url: url
                        });

                        currentRoute = route;
                    }
                })
            } while (currentRoute);
            this.pagevalues = this.links[this.links.length - 1];
            if (this.pagevalues && this.pagevalues.label && this.pagevalues.label.nocontainerpadding) {
                this.nocontainerpadding = true;
            } else {
                this.nocontainerpadding = false;
            }
            if (this.pagevalues && this.pagevalues.label && this.pagevalues.label.hidebreadcrumbs) {
                this.hidebreadcrumbs = true;
            } else {
                this.hidebreadcrumbs = false;
            }
        })

    }

    private setAppType(): void {
        this.userdata = this.auth.getCurrentUserData();
    }

    private setMenuItems(): void {
        if (this.userdata && this.userdata.appId) {
            this.menuitemFilter.where["appId"] = this.userdata.appId;
            this.menuitemFilter.where["accesslevel"] = this.userdata.accounttype;
            this.menuitemFilter.order = "index";
            this.MenuitemApi.find(this.menuitemFilter).subscribe((results) => {
                this.menuitems = results;
                if (this.userdata.role == 'administrator') {
                    this.menuitems.splice(1, 0, {
                        isdropdown: false,
                        label: "Access Group",
                        link: "/#/accessgroup",
                        linktype: "directlink",
                        name: "accessgroup",
                        submenu: []
                    });
                }
                for (var i = 0; i < this.menuitems.length; i++) {
                    if (this.menuitems[i].submenu && this.menuitems[i].submenu.length && this.menuitems[i].submenu.length > 0) {
                        this.menuitems[i].isdropdown = true;
                    }
                    else {
                        this.menuitems[i].isdropdown = false;
                    }
                }
            });
        } else {
            this.menuitems = [];
        }

    }

    public toggled(open: boolean): void {
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    public logout(): void {
        PlatformApp.removeApp();
        this.accountApi.logout();
        this.router.navigate(['/login']);
    }

    private loadtasks(): void {
        console.log('lets load the tasks')
    }

    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/full-layout/full-layout.component.ts